import { defineComponent as _defineComponent } from 'vue'
import { normalizeStyle as _normalizeStyle, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "add-client-modal" }
const _hoisted_2 = { class: "add-client-modal__search" }
const _hoisted_3 = {
  key: 0,
  class: "add-client-modal__close"
}
const _hoisted_4 = ["onClick", "innerHTML"]
const _hoisted_5 = {
  key: 2,
  class: "add-client-modal__body-empty"
}

import { computed, nextTick, onMounted, ref, watch } from "vue";
import AppCheckbox from "@/components/ui-kit/checkbox/AppCheckbox.vue";
import AppInput from "@/components/ui-kit/input/AppInput.vue";
import AppLoader from "@/components/common/AppLoader.vue";
import { clientsStore } from "@/store/clients";
import { debounce } from "lodash";
import AppIcon from "@/components/ui-kit/icon/AppIcon.vue";
import { AnalyticsApi } from "@/ api/AnalyticsApi";

type AnalyticsList = {
  Id: number;
  Name: string;
  Position: number;
};

type Props = {
  id: number;
  entityType?: number;
  addedLists: any[];
  showCloseIcon?: boolean;
}

const take = 60;

export default /*@__PURE__*/_defineComponent({
  __name: 'MainInfoListSelect',
  props: {
    id: {},
    entityType: { default: 4 },
    addedLists: {},
    showCloseIcon: { type: Boolean }
  },
  emits: ["close", "addList"],
  setup(__props: any, { emit: __emit }) {

const props = __props;

const emit = __emit;

const $input = ref<typeof AppInput | null>(null);
const $body = ref<HTMLDivElement | null>(null);

const isLoading = ref(true);
const fileId = ref<number | null>(null);
const filter = ref("");
const skip = ref(0);
const canLoadNext = ref(true);
const isListInit = ref(false);
const lists = ref<AnalyticsList[] | null>(null);
const existLists = computed(() => props.addedLists ?? []);

const filteredLists = computed(() => {
  if (!lists.value) return [];

  let result: AnalyticsList[] = [];

  if (existLists.value.length) {
    const sorted = [...existLists.value];

    lists.value.forEach((item) => {
      if (!existLists.value.find((c) => c.Id === item.Id)) {
        sorted.push(item);
      }
    });

    result = sorted;
  } else {
    result = [...lists.value];
  }

  result.sort((a, b) =>
    a.Name.localeCompare(b.Name, "ru", { sensitivity: "base" }),
  );

  if (!filter.value) return result;

  const search = filter.value.toLowerCase();

  return result.filter((item) => item.Name.toLowerCase().includes(search));
});

const loaderStyle = computed(() => ({
  "background-color": "rgba(255, 255, 255, 0.5)",
}));

const highlightText = (text: string) => {
  if (!filter.value) return escapeHtml(text);

  const lowerText = text.toLowerCase();
  const lowerSearch = filter.value.toLowerCase();

  const startIndex = lowerText.indexOf(lowerSearch);

  if (startIndex === -1) {
    return escapeHtml(text);
  }

  const endIndex = startIndex + filter.value.length;

  const before = text.substring(0, startIndex);
  const match = text.substring(startIndex, endIndex);
  const after = text.substring(endIndex);

  return `${escapeHtml(
    before,
  )}<span style="background-color:#D3E3FD;border-radius:4px;padding:1px;">${escapeHtml(
    match,
  )}</span>${escapeHtml(after)}`;
};

const escapeHtml = (text: string): string => {
  const div = document.createElement("div");
  div.textContent = text;
  return div.innerHTML;
};

const enter = () => {
  if (
    !existLists.value.includes(filteredLists.value[0]) &&
    filter.value &&
    filteredLists.value.length !== 0
  ) {
    onChangeListStage(true, filteredLists.value[0].Id);
  }
};

const onOpen = async () => {
  try {
    // existLists.value = props.addedLists;
    console.log(props.entityType)
    fileId.value = props.id;
    await onFetchLists();
    isListInit.value = true;
    await nextTick(() => $input.value?.focusInput());
    // console.log(
    //   "listOfElement",
    //   await AnalyticsApi.getListOfElement(props.fileId),
    // );
  } catch (e) {
    console.error(e);
  }
};

const onSearch = async () => {
  $body.value?.scrollTo({
    top: 0,
  });
  canLoadNext.value = true;
  skip.value = 0;
  await onFetchLists();
};

const debouncedSearch = debounce(onSearch, 500);

const onFetchLists = async () => {
  try {
    if (canLoadNext.value) {
      isLoading.value = true;
      const listsArray = await AnalyticsApi.getList(
        filter.value,
        0,
        props.entityType,
        fileId.value as number,
      );
      lists.value = [];
      lists.value =
        skip.value === 0
          ? listsArray.Lists
          : lists.value
          ? [...lists.value, ...listsArray.Lists]
          : listsArray.Lists;
      skip.value += take;
    }
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onAddElementToList = async (listId: number) => {
  try {
    isLoading.value = true;
    await AnalyticsApi.addElementToList(listId, '', props.entityType, props.id);
    // existLists.value.
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onAddElementToNewList = async (listId: number) => {
  try {
    isLoading.value = true;
    await AnalyticsApi.addElementToList(listId, filter.value, props.entityType, props.id);
    emit("addList");
    await onFetchLists();
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const onDeleteFileFromList = async (listId: number) => {
  try {
    isLoading.value = true;
    await AnalyticsApi.removeElementIntoList(listId, props.entityType, props.id);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};

const dropAllLists = async () => {
  try {
    isLoading.value = true;
    await detachAllClientsFromContact(
      fileId.value as number,
      existLists.value.map((client) => client.Id),
      existLists.value[0].Id,
    );

    existLists.value.splice(0);
  } catch (e) {
    console.error(e);
  } finally {
    isLoading.value = false;
  }
};
const detachAllClientsFromContact = async (
  fileId: number,
  listIds: number[],
  lastExistClientId: number,
) => {
  try {
    await Promise.allSettled(
      listIds.map((id) => AnalyticsApi.removeElementIntoList(id, props.entityType, fileId)),
    );
  } catch (e) {
    console.error(e);
  }
};

const isListAdded = (clientId: number) => {
  return !!existLists.value.find((client) => client.Id === clientId);
};

const onChangeListStage = async (stage: boolean, clientId: number) => {
  if (lists.value) {
    if (stage) {
      await onAddElementToList(clientId);
      existLists.value.push(
        lists.value.find((client) => client.Id === clientId)!,
      );
    } else {
      await onDeleteFileFromList(clientId);
      existLists.value.splice(
        existLists.value.findIndex((client) => client.Id === clientId),
        1,
      );
    }
  }
};

const onChangeClientStageFromName = async (fileId: number) => {
  if (lists.value) {
    if (existLists.value.find((client) => client.Id === fileId)) {
      await onDeleteFileFromList(fileId);
      existLists.value.splice(
        existLists.value.findIndex((client) => client.Id === fileId),
        1,
      );
    } else {
      await onAddElementToList(fileId);
      existLists.value.push(
        lists.value.find((client) => client.Id === fileId)!,
      );
    }
  }
};

watch(filter, (newVal, oldVal) => {
  if (newVal !== oldVal) {
    debouncedSearch();
  }
});

watch(isListInit, (newValue) => {
  if (newValue) {
    nextTick(() => {
      $body.value?.addEventListener("scroll", async () => {
        if (canLoadNext.value && !isLoading.value) {
          if (
            $body.value?.scrollTop! + $body.value?.offsetHeight! >
            $body.value?.scrollHeight! - 500
          ) {
            await onFetchLists();
          }
        }
      });
    });
  }
});

onMounted(() => onOpen());

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (isLoading.value)
      ? (_openBlock(), _createBlock(AppLoader, {
          key: 0,
          style: _normalizeStyle(loaderStyle.value)
        }, null, 8, ["style"]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_2, [
      _createVNode(AppInput, {
        ref_key: "$input",
        ref: $input,
        modelValue: filter.value,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((filter).value = $event)),
        class: "add-client-modal__search-input",
        placeholder: "Поиск",
        "show-add-button": "",
        "add-hint-text": 'Создать и добавить список',
        onAdd: onAddElementToNewList,
        onPressEnter: enter
      }, null, 8, ["modelValue"]),
      (props.showCloseIcon)
        ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
            _createVNode(AppIcon, {
              class: "create-edit-contact__body-tags-item-delete",
              name: "close",
              width: "20px",
              color: "#D2D2D2",
              "hover-color": "#499259",
              cursor: "pointer",
              title: "Закрыть",
              onClick: _cache[1] || (_cache[1] = ($event: any) => (emit('close')))
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", { class: "add-client-modal__header" }, [
      _cache[2] || (_cache[2] = _createElementVNode("div", { class: "add-client-modal__header-title" }, "Доступные списки", -1)),
      _createElementVNode("div", {
        class: "add-client-modal__header-drop-btn",
        onClick: dropAllLists
      }, " Сбросить ")
    ]),
    (filteredLists.value?.length)
      ? (_openBlock(), _createElementBlock("div", {
          key: 1,
          class: "add-client-modal__body",
          ref_key: "$body",
          ref: $body
        }, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(filteredLists.value, (element) => {
            return (_openBlock(), _createElementBlock("div", {
              class: "add-client-modal__body-item",
              key: element.Id
            }, [
              _createVNode(AppCheckbox, {
                style: { height: '16px', marginRight: '8px' },
                value: isListAdded(element.Id),
                text: "",
                onInput: ($event: any) => (onChangeListStage($event, element.Id))
              }, null, 8, ["value", "onInput"]),
              _createElementVNode("div", {
                class: "add-client-modal__body-item-text",
                onClick: ($event: any) => (onChangeClientStageFromName(element.Id)),
                innerHTML: highlightText(element.Name)
              }, null, 8, _hoisted_4)
            ]))
          }), 128))
        ], 512))
      : (_openBlock(), _createElementBlock("div", _hoisted_5, _cache[3] || (_cache[3] = [
          _createElementVNode("div", { class: "add-client-modal__body-item-text" }, "Список не найден", -1)
        ])))
  ]))
}
}

})